import {createEntityService} from 'utils/createEntityService';
import {JobRole} from '../types/jobRole';

export const JobRoleService = createEntityService<JobRole>({
  baseUrl: 'api/v1/job_roles',
  entityName: 'jobRole',
});
